import styled from 'styled-components';

export const LanguageSwitcherContainer = styled.button`
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 20px;
    transition: all 0.2s ease;
    background: transparent;
    border: none;

    &:hover {
        background-color: #f5f5f5;
    }

    svg {
        height: 20px;
        width: 20px;
        color: rgba(29, 42, 65, 1);
        opacity: 0.8;
        transition: opacity 0.2s ease;
    }

    &:hover svg {
        opacity: 1;
    }
`;

export const LanguageLabel = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: rgba(29, 42, 65, 1);
    user-select: none;
    opacity: 0.8;
    transition: opacity 0.2s ease;

    ${LanguageSwitcherContainer}:hover & {
        opacity: 1;
    }
`;

export const LanguageDropdown = styled.div<{ $isOpen: boolean }>`
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    min-width: 150px;
    overflow: hidden;
    z-index: 1000;
    opacity: ${props => props.$isOpen ? '1' : '0'};
    visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
    transform: ${props => props.$isOpen ? 'translateY(0)' : 'translateY(-10px)'};
    transition: all 0.3s ease;
`;

export const LanguageOption = styled.button<{ $isActive: boolean }>`
    padding: 12px 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
    border: none;
    width: 100%;
    text-align: left;
    border-radius: 16px;
    color: ${props => props.$isActive ? 'rgba(29, 42, 65, 1)' : '#333'};
    font-weight: ${props => props.$isActive ? '600' : '400'};
    background: ${props => props.$isActive ? '#f5f5f5' : 'transparent'};

    &:hover {
        background-color: #f5f5f5;
    }
`;
